module.exports = __webpack_public_path__ + "img/certificate3.588cdb30.jpg";